// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"CsLoading__ldsSpinner__n6ke2"};